export enum RoomRatePlanForms {
  Create = 'CreateRoomRatePlan',
  Edit = 'EditRoomRatePlan',
}
